import { useCallback, useState } from 'react'

import { Dialog } from '@inno-ui/dialog'
import {
  ChevronDownIcon,
  ChevronUpIcon,
  IconSizes,
  IconWeight
} from '@inno-ui/icons'
import { Radio } from '@inno-ui/radio'
import cn from 'clsx'
import { useTranslation } from 'react-i18next'
import { useLanguageSelector } from 'shared/hooks/useLanguageSelector'

import styles from './AuthLanguageSelector.module.scss'
import { AuthLanguageSelectorProps } from './AuthLanguageSelector.types'

export const AuthLanguageSelector = ({
  inline = false
}: AuthLanguageSelectorProps) => {
  const [isOpen, setIsOpen] = useState(false)
  const { t } = useTranslation()

  const handleToggle = useCallback(() => setIsOpen(true), [])

  const { changeLanguage, currentLanguageOption, languageOptions } =
    useLanguageSelector()

  const Icon = isOpen ? ChevronUpIcon : ChevronDownIcon

  const trigger = (
    <button
      type='button'
      className={cn(styles.trigger, {
        [styles.isOpen]: isOpen,
        [styles.inline]: inline
      })}
      onClick={handleToggle}
      aria-haspopup='dialog'
      aria-expanded={isOpen}
      aria-label={t('navbar.userMenu.changeLanguage')}
    >
      <img
        src={currentLanguageOption.icon}
        alt={currentLanguageOption.label}
        className={styles.flag}
      />
      <span className={styles.label}>{currentLanguageOption.value}</span>
      <Icon
        color='var(--primary-blue-light)'
        weight={IconWeight.Bold}
        size={IconSizes.Size14}
      />
    </button>
  )

  const dropdown = (
    <div className={styles.dropdown}>
      {languageOptions.map(lang => (
        <Radio
          key={lang.value}
          onClick={() => {
            changeLanguage(lang.value)
            setIsOpen(false)
          }}
          label={lang.label}
          checked={currentLanguageOption.value === lang.value}
        />
      ))}
    </div>
  )

  return (
    <Dialog
      isOpen={isOpen}
      body={dropdown}
      setIsOpen={setIsOpen}
      onClose={() => setIsOpen(false)}
      triggerAutoZIndex
      hideHeader
    >
      {trigger}
    </Dialog>
  )
}
